import { useState } from "react";
import "./teacher-info-style.css";

//老師資訊折疊卡（問問老師、專業諮詢共用）
//  頭像+名字常駐撐信任感，點開看完整學經歷與專精八領域
//  內容取自品牌故事頁的帝鎧老師介紹
const TeacherInfo = ({ defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`teacher-info${open ? " open" : ""}`}>
      <button
        type="button"
        className="teacher-head"
        onClick={() => setOpen((v) => !v)}
      >
        <img className="avatar" src="/images/teacher.jpeg" alt="帝鎧老師" />
        <div className="meta">
          <span className="name">帝鎧老師</span>
          <span className="tagline">命理工程師 · 專精八大領域，親自回覆</span>
        </div>
        <span className="toggle">{open ? "收合 ▴" : "認識老師 ▾"}</span>
      </button>

      <div className="teacher-body">
        <p className="des">
          融合科技與傳統智慧的命理專家。畢業於臺灣科技大學電子研究所碩士班，擁有多年
          App 開發經驗，同時深耕東方命理與風水領域，致力於將古老智慧以現代科技形式呈現，打造實用又可信賴的命理服務。
        </p>
        <p className="fields-title">專精八大領域</p>
        <div className="fields">
          <span>八字命理流年推算</span>
          <span>姓名學諮詢與改名建議</span>
          <span>文王聖卦（六爻占卜）</span>
          <span>陽宅風水佈局規劃</span>
          <span>紫微斗數全盤解讀</span>
          <span>嬰兒擇日剖腹吉時</span>
          <span>奇門遁甲開運布局</span>
          <span>符咒能量開運調理</span>
        </div>
      </div>
    </div>
  );
};

export default TeacherInfo;
